/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Flow_AssignInputs */

const en_mk_team_flow_assign = /** @type {(inputs: Mk_Team_Flow_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01 · Assign tasks to separate working folders`)
};

const id_mk_team_flow_assign = /** @type {(inputs: Mk_Team_Flow_AssignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`01 · Bagikan tugas ke folder kerja masing-masing`)
};

/**
* | output |
* | --- |
* | "01 · Assign tasks to separate working folders" |
*
* @param {Mk_Team_Flow_AssignInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_flow_assign = /** @type {((inputs?: Mk_Team_Flow_AssignInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Flow_AssignInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_flow_assign(inputs)
	return en_mk_team_flow_assign(inputs)
});